export default __webpack_public_path__ + "static/summer_containers42-bca1b10984715149bf222205ea2d24f0.webp";